import { Injectable } from "@angular/core";
import { ExamService } from "../services/exam-service.service";
import { tr } from "date-fns/locale";
import { AuthService } from "../services/http-services/authservice.service";
import { examDefault } from "../interface/dtoDefaults";
import { ExamScheduleService } from "../services/exam-schedule-service";
import { QuestionBankService } from "../questions-bank/question-bank.service";

@Injectable({
    providedIn: 'root'
})
export class OperationStatus {
    listMultiOperations: string[] = [
        'operations/exam/import_candidates_data', 'operations/exam/downloadExamCandidates',
        'operations/exam/publish_questions', 'operations/exam/test', 'operations/exam/pausestatus'];
    constructor(private examService: ExamService, private authService: AuthService, private examSchService: ExamScheduleService,private questionBankService: QuestionBankService,) { }

    // This function is used to check if the operation is disabled(true) or not
    isOperationDisabled(operationRoute: string, id: string) {
        let selectedExam = examDefault;

        if (this.examService.selectedExams && this.examService.selectedExams?.length > 0) {
            selectedExam = this.examService.selectedExams[0];
        }
        if (!this.authService.hasPermission(id)) {
            return true;//if user does not have permission
        }
        if (operationRoute == 'operations/exam/generatedps' || operationRoute == 'operations/exam/generatedps') {
            return (selectedExam.liveProctoring ? false : true);
        }
        if (operationRoute == 'operations/exam/autoMarkSAQ' || operationRoute == 'operations/exam/markSaq' || operationRoute.endsWith('/updatesaqanswers')) {
            return (selectedExam.examinationTypeenum !== "SAQ");
        }
        if (operationRoute == 'operations/exam/reviewSaq') {
            return (selectedExam.examinationTypeenum !== "SAQ");
        }
        if (operationRoute == 'operations/exam/markEssay') {
            return selectedExam.examinationTypeenum !== "Essay";
        }
        if (operationRoute == 'operations/exam/reviewEssay') {
            return selectedExam.examinationTypeenum !== "Essay";
        }
        if (operationRoute == 'operations/exam/assignexaminers') {
            return selectedExam.examinationTypeenum !== "Essay" && selectedExam.examinationTypeenum !== "SAQ";
        }
        if (operationRoute == 'operations/exam/monitor') {
            return (selectedExam.liveProctoring ? false : true);
        }
        //if (operationRoute == 'operations/exam/recordings') {
        //    return (selectedExam.liveProctoring || selectedExam.aIProctoring || selectedExam.recording || selectedExam.facialRecognition ? false : true);
        //}
        if (operationRoute == 'operations/exam/flags') {
            return (selectedExam.liveProctoring || selectedExam.aIProctoring || selectedExam.facialRecognition ? false : true);
        }

        if (operationRoute.startsWith("/exams/") && operationRoute.endsWith("/questionbanks")) {
            return !selectedExam.useQuestionBank;
        }

        if (operationRoute == 'operations/questions-bank/question/upload') {
            return !(this.questionBankService.selectedQuestionBanks[0]?.questionType === 'Multiple-Choice' && !this.questionBankService.selectedQuestionBanks[0].isPsychometricTestBank)
        }

        if (operationRoute.includes('psychometric-report')) {
            return !(selectedExam.psychometricTest)
        }

        if (this.examService.selectedExams?.length > 1) {
            // if multiple exams are selected, disable the operation;
            if (!this.listMultiOperations.includes(operationRoute)) {
                return true; // disable the operation
            }
        }

        return false;//if user has permission
    }
}